import { observable, action, runInAction } from 'mobx'
import posterApi from '@api/poster'
import { dGet } from '@core/utils'
import { gotoPoster } from '@util'
export default class {
  @observable poster = {}
  /**
   * 获取poster参数
   */
  @action
  init = async () => {
    const { data = {} } = await posterApi.poster(5005)
    const holes = dGet(
      data,
      'floors.SITE_MERCHANT_LIVE_REPORT_RIGHT_BANNER.holes',
      ''
    )
    if (Object.prototype.toString.call(holes) === '[object Array]') {
      runInAction(() => (this.poster = holes[0] ? holes[0].posters : ''))
    }
  }
  /**跳转优秀案例 */
  @action
  gotoSuperCase = () => {
    gotoPoster(this.poster)
  }
}
